export class sort {
   direction: 'ASC' | 'DESC';
   name: string;
   level: number;
}
export class StorageSortModel {
   gridName:string;
   sortList:sort[];
}